import React, { useState, useEffect } from 'react';
import WalletConnection from './components/WalletConnection';
import TransactionForm from './components/TransactionForm';
import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    document.body.style.backgroundColor = isDarkMode ? '#121212' : '#f5f5f5';
  }, [isDarkMode]);

  const handleCopyAddress = () => {
    navigator.clipboard.writeText('A6dXNxJH3vGLJRhVFBm8vQkd2eRE2QXnYS5SXBWKLLCV');
    toast.success('Address copied to clipboard!', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: isDarkMode ? "dark" : "light"
    });
  };

  return (
    <div className={`App ${isDarkMode ? 'dark' : 'light'}`}>
      <ToastContainer />
      <div style={{
        textAlign: 'center',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: isDarkMode ? '#e9ecef' : '#212529', 
          marginBottom: '20px'
        }}>
          Solana Secured Message Sender (on-chain)
        </h1>
      </div>

      <div style={{ 
        color: isDarkMode ? '#adb5bd' : '#6c757d',
        marginBottom: '30px',
        fontSize: '0.9rem',
        textAlign: 'center'
      }}>
        Support this project by sending tips to:{' '}
        <span 
          onClick={handleCopyAddress}
          style={{ 
            cursor: 'pointer',
            textDecoration: 'underline',
            color: isDarkMode ? '#7e57c2' : '#512da8'
          }}
          title="Click to copy"
        >
          A6dXNxJH3vGLJRhVFBm8vQkd2eRE2QXnYS5SXBWKLLCV
        </span>
      </div>

      <WalletConnection>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '20px'
        }}>
          <TransactionForm isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
        </div>
      </WalletConnection>
    </div>
  );
}

export default App;